import * as dateFnsCompat from 'utils/date-fns-compat';

import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import { timezones } from 'react-timezone';
import { branch, compose, lifecycle, renderComponent, withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { contentStatus, CpdCategoryStatus, months, routes } from '../../../../constants';
import { PublishedEventTypes } from '../../../../constants/publishedEvent';
import { getIndustryLabelForCpdCategory, getIndustryLabelForCpdCategoryNoParenthesis, handleInvalidForm, isSystemAdmin } from '../../../../services';
import { cpdCategorysActions } from '../../../../state/modules/areas-of-advice';
import { contentConfigSelector } from '../../../../state/modules/configuration/selectors';
import { geonamesActions } from '../../../../state/modules/geonames';
import { activePublishersSelector } from '../../../../state/modules/publisher-portal/publisher/selectors';
import { currentUserSelector } from '../../../../state/modules/user';
import { noCapMap } from '../../../../utils';
import { ConfirmationModal, ControlGroup, ControlOption, FileUploadFormField, FormField, FormGroup, FormItem, Icon, InputFormField, NumberFormField, SelectFormField, TextAreaFormField, TypeaheadField } from '../../../components';
import Loading from '../../loading';

var moment = require('moment-timezone')

const LocationType = {
  physical: 'Face to face',
  virtual: 'Online'
}

const StartDateType = {
  defined: 'Time Dependent',
  undefined: 'Not Time Dependent'
}

const stringifyZone = (label, offset) => {
  const ensure2Digits = num => (num > 9 ? `${num}` : `0${num}`);

  return `(GMT${offset < 0 ? '-' : '+'}${ensure2Digits(Math.abs(offset))}:${ensure2Digits(Math.abs((offset % 1) * 60))}) ${label}`;
}

const getDefaultCpdPoint = (cpdCategorys) => ({
  cpdCategoryId: fp.first(cpdCategorys).id,
  points: 0
})

const EventDetails = ({
  publishedEventId,
  savePublishedEvent,
  publishedEvent: {
    link,
    title,
    description,
    eventStartTime,
    ignoreStartTime,
    durationDay,
    durationHour,
    durationMinute,
    ignoreDuration,
    price,
    location,
    suburb,
    postcode,
    publisherId,
    isTasaCpd,
    priceRange
  },
  tags,
  aoaCpdPoints,
  goals,
  toggleGoal,
  updateFormField,
  onEventStartTimeChange,
  onEventStatusChange,
  onCpdCategoryChange,
  eventStatusProps,
  setCpdPoints,
  removeAoaCpdPoints,
  addCpdCategory,
  cpdCategorys,
  newTag,
  updateNewTag,
  onAddTagKeyPress,
  removeTag,
  onPreviewImageDrop,
  previewImageFile,
  previewImageUrl,
  removePreviewImage,
  config,
  validation,
  setFormRef,
  isUpdatingPublishedEvent,
  isSystemAdmin,
  suburbSearchText,
  geonames,
  onSuburbTextChange,
  onSuburbSelected,
  onSuburbInputChange,
  suburbItem,
  renderSuburbResult,
  locationOption,
  onLocationOptionChange,
  getHours,
  period,
  publishers,
  setHours,
  setPeriod,
  setTimezone,
  showDeleteModel,
  timezone,
  timezoneOffsets,
  deletePublishedEvent,
  deleteEvent,
  closeDeleteModel,
  onIsTasaCpdChange,
  onIgnoreStartTimeChange,
  onIgnoreDurationChange,
  eventType,
  startDateOption,
  onStartDateOptionChange,
  industriesWithCpdCategorys,
  duplicateDisabled,
  duplicate
}) => (
    <section>
      <Grid>
        <h1 className='text-center'>{eventType} Details</h1>
        <Row className='md-gutter'>
          <Col xs={12} md={8} mdOffset={2} className='boxed text-left'>
            <form ref={setFormRef} noValidate>
              {
                publishers.length > 1 ?
                  <fieldset>
                    <FormField id='publisher-id' label='Publisher' type='select-item'>
                      <select
                        id='publisher-id'
                        value={publisherId || ''}
                        required
                        onChange={(e) => updateFormField({ name: 'publisherId', value: parseInt(e.target.value, 10) })}>
                        {publisherId ? null : <option value={''}></option>}
                        {
                          fp.compose(
                            fp.map(({ id, name }) => <option value={id} key={id}>{he.decode(name)}</option>),
                            fp.sortBy(({ name }) => fp.lowerCase(name))
                          )(publishers)
                        }
                      </select>
                    </FormField>
                  </fieldset> :
                  null
              }
              <fieldset>
                <InputFormField
                  id='link'
                  label='URL'
                  required
                  validation={validation.link ? null : 'URL is required.'}
                  value={he.decode(link)}
                  onChange={(e) => updateFormField({ name: e.target.name, value: he.encode(e.target.value) })} />
                <InputFormField
                  id='title'
                  label='Title'
                  required
                  validation={validation.title ? null : 'Title is required.'}
                  value={he.decode(title)}
                  onChange={(e) => updateFormField({ name: e.target.name, value: he.encode(e.target.value) })} />
                <TextAreaFormField
                  id='description'
                  label={`Description of ${fp.toLower(eventType)}`}
                  required
                  validation={validation.description ? null : `Description of ${fp.toLower(eventType)} is required.`}
                  value={he.decode(description)}
                  onChange={(e) => updateFormField({ name: e.target.name, value: he.encode(e.target.value) })} />
                <ControlGroup
                  id='location-option'
                  control='radio'
                  type='pill'
                  label={'Location option'}
                  onChange={(e) => onLocationOptionChange(e.target.value)}>
                  <ControlOption value={LocationType.physical} checked={locationOption === LocationType.physical} type={'radio'} label={<span>{LocationType.physical}</span>} />
                  <ControlOption value={LocationType.virtual} checked={locationOption === LocationType.virtual} type={'radio'} label={<span>{LocationType.virtual}</span>} />
                </ControlGroup>
                <div className={locationOption === LocationType.virtual ? 'hidden' : null}>
                  <InputFormField
                    id='location'
                    label='Location'
                    value={he.decode(location)}
                    onChange={(e) => updateFormField({ name: e.target.name, value: he.encode(e.target.value) })} />
                  {
                    locationOption === LocationType.physical ?
                      <TypeaheadField
                        id='suburb'
                        required
                        label='Suburb'
                        searchText={suburb || suburbSearchText}
                        isLoading={geonames.isFetching}
                        emptyLabel={geonames.isFetching ? 'Searching...' : 'No matches'}
                        options={geonames ? geonames.suburbs : []}
                        labelKey={suburbItem}
                        renderMenuItemChildren={renderSuburbResult}
                        onSearch={(v) => onSuburbTextChange(v)}
                        onChange={(v) => onSuburbSelected(v)}
                        onInputChange={(v) => onSuburbInputChange(v)}
                        selected={[{ placeName: suburb, postalCode: postcode }]}
                        validation={validation.suburb ? null : 'Suburb is required.'}
                      /> :
                      <InputFormField
                        inputProps={{ disabled: true }}
                        id='suburb'
                        label='Suburb'
                        value={LocationType.virtual}
                        onChange={(e) => updateFormField({ name: 'suburb', value: e.target.value })} />
                  }
                  <InputFormField
                    inputProps={{ disabled: locationOption === LocationType.virtual }}
                    id='postcode'
                    label='Postcode'
                    inputType='number'
                    required
                    validation={validation.postcode ? null : 'Postcode is required.'}
                    value={locationOption === LocationType.physical ? postcode : '0'}
                    onChange={(e) => updateFormField({ name: 'postcode', value: e.target.value })} />
                </div>
              </fieldset>
              <fieldset>
                <NumberFormField
                  id='price'
                  label='Price (Fr. $)'
                  value={price}
                  onChange={(e) => updateFormField({ name: 'price', value: e.value })}
                  required
                  validation={validation.price ? null : 'price is required.'}
                  min={0}
                  step={1} />
                {/* We want to ignore price range for now */}
                {/* <InputFormField
                  id='priceRange'
                  label='PriceRange'
                  required
                  value={he.decode(priceRange)}
                  onChange={(e) => updateFormField({ name: e.target.name, value: he.encode(e.target.value) })} /> */}
              </fieldset>
              {
                eventType === PublishedEventTypes.Course ?
                  <ControlGroup
                    id='start-date-option'
                    control='radio'
                    type='pill'
                    label={'Start date option'}
                    onChange={(e) => onStartDateOptionChange(e.target.value)}>
                    <ControlOption value={StartDateType.defined} checked={startDateOption === StartDateType.defined} type={'radio'} label={<span>{StartDateType.defined}</span>} />
                    <ControlOption value={StartDateType.undefined} checked={startDateOption === StartDateType.undefined} type={'radio'} label={<span>{StartDateType.undefined}</span>} />
                  </ControlGroup> : null
              }
              {
                startDateOption === StartDateType.defined ? <div>
                  <fieldset>
                    <FormItem>
                      <h2>Start Date</h2>
                    </FormItem>
                    <Row>
                      <Col xs={12} md={4}>
                        <FormField id='event-start-time-day' label='Day' type='select-item' required>
                          <select
                            id='event-start-time-day'
                            value={dateFnsCompat.getDate(eventStartTime)}
                            required
                            onChange={(e) => onEventStartTimeChange(dateFnsCompat.setDate, e.target.value)}>
                            {
                              fp.map((day) =>
                                <option key={day} value={day}>{day}</option>
                              )(fp.times((x) => x + 1)(dateFnsCompat.getDaysInMonth(eventStartTime)))
                            }
                          </select>
                        </FormField>
                      </Col>
                      <Col xs={12} md={4}>
                        <FormField id='event-start-time-month' label='Month' type='select-item' required>
                          <select
                            id='event-start-time-month'
                            value={dateFnsCompat.getMonth(eventStartTime)}
                            required
                            onChange={(e) => onEventStartTimeChange(dateFnsCompat.setMonth, e.target.value)}>
                            {
                              noCapMap((month, index) =>
                                <option key={index} value={index}>{month}</option>
                              )(fp.values(months))
                            }
                          </select>
                        </FormField>
                      </Col>
                      <Col xs={12} md={4}>
                        <FormField id='event-start-time-year' label='Year' type='select-item' required>
                          <select
                            id='event-start-time-year'
                            value={dateFnsCompat.getYear(eventStartTime)}
                            required
                            onChange={(e) => onEventStartTimeChange(dateFnsCompat.setYear, e.target.value)}>
                            {
                              fp.map((year) =>
                                <option key={year} value={year}>{year}</option>
                              )(fp.range(2010)(dateFnsCompat.getYear(dateFnsCompat.addYears(new Date(), 2))))
                            }
                          </select>
                        </FormField>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12}>
                        <FormGroup
                          id='event-start-time'
                          validation={validation.eventStartTime ? null : `${eventType} start time must be in the future.`}>
                        </FormGroup>
                      </Col>
                    </Row>
                  </fieldset>
                  <fieldset>
                    <FormItem>
                      <h2>Start Time</h2>
                    </FormItem>
                    <Row>
                      <Col xs={12}>
                        <ControlGroup
                          id='ignore-start-time'
                          className='no-margin'
                          control='checkbox'
                          type='styled'
                          label={<span></span>}
                          onChange={(e) => onIgnoreStartTimeChange(e)}
                          colProps={{ xs: 12, sm: 3 }}>
                          <ControlOption
                            className='no-margin'
                            value={ignoreStartTime}
                            label={<span>Ignore Start Time</span>}
                            checked={ignoreStartTime} />
                        </ControlGroup>
                      </Col>
                    </Row>
                    {
                      ignoreStartTime ? null : <Row>
                        <Col xs={12} md={4}>
                          <FormField id='event-start-time-hour' label='Hour' type='select-item' required>
                            <select
                              id='event-start-time-hour'
                              value={getHours(eventStartTime)}
                              required
                              onChange={(e) => onEventStartTimeChange(setHours, e.target.value)}>
                              {
                                fp.map((hour) =>
                                  <option key={hour} value={hour}>{hour}</option>
                                )(fp.range(1, 13))
                              }
                            </select>
                          </FormField>
                        </Col>
                        <Col xs={12} md={4}>
                          <FormField id='event-start-time-minute' label='Minute' type='select-item' required>
                            <select
                              id='event-start-time-minute'
                              value={dateFnsCompat.getMinutes(eventStartTime)}
                              required
                              onChange={(e) => onEventStartTimeChange(dateFnsCompat.setMinutes, e.target.value)}>
                              {
                                fp.map((min) =>
                                  <option key={min} value={min}>{min}</option>
                                )(fp.range(0, 60))
                              }
                            </select>
                          </FormField>
                        </Col>
                        <Col xs={12} md={4}>
                          <FormField id='event-start-time-period' label='Period' type='select-item' required>
                            <select
                              id='event-start-time-period'
                              value={period}
                              required
                              onChange={(e) => setPeriod(e.target.value)}>
                              <option key={0} value='AM'>AM</option>
                              <option key={1} value='PM'>PM</option>
                            </select>
                          </FormField>
                        </Col>
                      </Row>
                    }
                    <Row>
                      <Col xs={12} md={12}>
                        <FormGroup
                          id='event-start-time'
                          validation={validation.eventStartTime ? null : `${eventType} start time must be in the future.`}>
                        </FormGroup>
                      </Col>
                    </Row>
                  </fieldset>
                  <fieldset>
                    <FormItem>
                      <h2>Timezone</h2>
                    </FormItem>
                    <FormField id='event-start-time-timezone' label='Timezone' type='select-item' required>
                      <select
                        id='event-start-time-timzone'
                        value={timezone.name}
                        required
                        onChange={(e) => setTimezone(fp.find(tz => tz.name === e.target.value)(timezoneOffsets))}>
                        {
                          fp.map((tz) =>
                            <option key={tz.name} value={tz.name}>{stringifyZone(tz.label, tz.offset)}</option>
                          )(timezoneOffsets)
                        }
                      </select>
                    </FormField>
                  </fieldset>
                </div> : null
              }
              <fieldset>
                <FormItem>
                  <h2>Duration</h2>
                </FormItem>
                <Row>
                  <Col xs={12}>
                    <ControlGroup
                      id='ignore-duration'
                      className='no-margin'
                      control='checkbox'
                      type='styled'
                      label={<span></span>}
                      onChange={(e) => onIgnoreDurationChange(e)}
                      colProps={{ xs: 12, sm: 3 }}>
                      <ControlOption
                        className='no-margin'
                        value={ignoreDuration}
                        label={<span>Ignore Duration</span>}
                        checked={ignoreDuration} />
                    </ControlGroup>
                  </Col>
                </Row>
                {

                  ignoreDuration ? null : <Row>
                    <Col xs={12} md={4}>
                      <FormField id='durationDay' label='Day' type='select-item' required>
                        <select
                          id='durationDay'
                          value={durationDay}
                          required
                          onChange={(e) => updateFormField({ name: 'durationDay', value: e.target.value })}>
                          {
                            fp.map((day) =>
                              <option key={day} value={day}>{day}</option>
                            )(fp.range(0)(30))
                          }
                        </select>
                      </FormField>
                    </Col>
                    <Col xs={12} md={4}>
                      <FormField id='durationHour' label='Hour' type='select-item' required>
                        <select
                          id='durationHour'
                          value={durationHour}
                          required
                          onChange={(e) => updateFormField({ name: 'durationHour', value: e.target.value })}>
                          {
                            noCapMap((hour) =>
                              <option key={hour} value={hour}>{hour}</option>
                            )(fp.range(0)(12))
                          }
                        </select>
                      </FormField>
                    </Col>
                    <Col xs={12} md={4}>
                      <FormField id='durationMinute' label='Minute' type='select-item' required>
                        <select
                          id='durationMinute'
                          value={durationMinute % 60}
                          required
                          onChange={(e) => updateFormField({ name: 'durationMinute', value: e.target.value })}>
                          {
                            noCapMap((minute) =>
                              <option key={minute} value={minute}>{minute}</option>
                            )(fp.range(0)(60))
                          }
                        </select>
                      </FormField>
                    </Col>
                  </Row>
                }
                <Row>
                  <Col xs={12} md={12}>
                    <FormGroup
                      id='event-duration'>
                    </FormGroup>
                  </Col>
                </Row>
              </fieldset>
              <fieldset className='no-margin'>
                <Row>
                  <Col xs={12}>
                    <FormItem>
                      <h2>CPD Hours Earned</h2>
                    </FormItem>
                    <Row className='xs-gutter'>
                      {
                        fp.flow(
                          noCapMap(({ cpdCategoryId, points }, index) =>
                            <Col key={index} xs={12}>
                              <Row className='xs-gutter'>
                                <Col xs={9}>
                                  <SelectFormField
                                    formGroupProps={{ className: 'clearfix' }}
                                    id={`cpdCategory${index}`}
                                    name={`cpdCategorys[${index}].cpdCategoryId`}
                                    label='CPD Category'
                                    onChange={(e) => onCpdCategoryChange(index, e.target.value)}
                                    required
                                    emptyOption={false}
                                    value={cpdCategoryId ? `${cpdCategoryId}` : ''}>
                                    {
                                      fp.flow(
                                        fp.filter(({ status }) => status === CpdCategoryStatus.active),
                                        fp.sortBy(aoa => aoa.name),
                                        fp.map(
                                          ({ id, name }) => {
                                            const industries = getIndustryLabelForCpdCategory(id, industriesWithCpdCategorys)
                                            return <option key={id} value={id}>
                                              {he.decode(name)}{industries}
                                            </option>
                                          }
                                        )
                                      )(cpdCategorys)
                                    }
                                  </SelectFormField>
                                </Col>
                                <Col xs={2}>
                                  <NumberFormField {...{
                                    id: `points${index}`,
                                    label: 'CPD Hours',
                                    min: 0,
                                    step: 0.25,
                                    onChange: (e) => setCpdPoints(index, e.value),
                                    required: true,
                                    value: points,
                                  }} />
                                </Col>
                                {
                                  cpdCategorys.length > 1 ?
                                    <Col xs={1}>
                                      <Button
                                        bsStyle='plain'
                                        className='large area-of-advice-remove pull-right'
                                        onClick={() => removeAoaCpdPoints(aoaCpdPoints[index])}>
                                        <Icon icon='close-thick' />
                                      </Button>
                                    </Col> : null
                                }
                              </Row>
                            </Col>
                          )
                        )(aoaCpdPoints)
                      }
                      {
                        fp.flow(
                          fp.map(
                            (aoaCpdPoint) => ({
                              ...aoaCpdPoint,
                              industry: getIndustryLabelForCpdCategoryNoParenthesis(aoaCpdPoint.cpdCategoryId, industriesWithCpdCategorys)
                            })
                          ),
                          fp.groupBy('industry'),
                          fp.toPairs,
                          fp.map(
                            ([industry, cpdPoints]) => <Col key={industry} xs={12}>
                              <Row className='xs-gutter readonly'>
                                <Col xs={9}>
                                  <p>{industry} Total:</p>
                                </Col>
                                <Col xs={2}>
                                  <p className='dark'>
                                    {
                                      fp.sumBy(({ points }) => points)(cpdPoints)
                                    }
                                  </p>
                                </Col>
                                <Col xs={1}>
                                </Col>
                              </Row>
                            </Col>
                          )
                        )(aoaCpdPoints)
                      }
                      {
                        cpdCategorys.length > 1 ?
                          <Col xs={12} className='flex-center'>
                            <Button
                              onClick={addCpdCategory}
                              className='mt-3'>
                              <Icon icon='add-large' /> Add CPD Category
                          </Button>
                          </Col> : null
                      }
                    </Row>
                    <FormGroup
                      id='aoaCpdPoints-validation'
                      validation={validation.aoaCpdPoints ?
                        validation.aoaCpdPointsUnique ? null
                          : 'You cannot list the same CPD category multiple times. Please update and try again.'
                        : 'There must be at least one CPD category with non-zero CPD hours.'}>
                    </FormGroup>
                  </Col>
                </Row>
              </fieldset>

              <fieldset>
                <ControlGroup
                  id='content-progress-goal'
                  control='checkbox'
                  type='styled'
                  label={<h3 className='no-margin'>Please select if relevant</h3>}
                  onChange={() => { }}
                  onClick={(e) => toggleGoal(parseInt(e.target.value, 10))}
                  colProps={{ xs: 12, sm: 4 }}>
                  {
                    fp.flow(
                      fp.map(
                        ({ industry, goals }) => fp.map(
                          (goal) => ({
                            ...goal,
                            industryId: industry.id
                          })
                        )(goals)
                      ),
                      fp.flatten,
                      fp.uniqBy('id'),
                      fp.map(
                        (goal) => <ControlOption key={goal.id} value={goal.id} label={<span>{goal.name}</span>} checked={fp.includes(goal.id)(goals)} />
                      )
                    )(industriesWithCpdCategorys)
                  }
                </ControlGroup>
              </fieldset>
              <fieldset className='tags-input'>
                <h2>Add tags</h2>
                <InputFormField id='tag' label='Add tag and press enter' value={newTag} onChange={updateNewTag} onKeyPress={onAddTagKeyPress} />
                {
                  tags.length ?
                    <FormGroup>
                      <FormItem>
                        <div className='bootstrap-tagsinput'>
                          {
                            fp.map(tag =>
                              <span key={tag} className='tag label label-info'>
                                {he.decode(tag)}
                                <span data-role='remove' aria-label={'Remove tag ' + tag} onClick={(e) => removeTag(tag)} />
                              </span>
                            )(tags)
                          }
                        </div>
                      </FormItem>
                    </FormGroup> :
                    null
                }
              </fieldset>
              <fieldset>
                <h2>Upload preview image</h2>
                {
                  previewImageFile ?
                    <div>
                      <div className='text-center preview-image new'><img alt={previewImageFile.name} src={previewImageFile.preview} /></div>
                      <button aria-label='Remove Image' className='btn preview-image' onClick={removePreviewImage}>
                        <Icon icon='close' />
                      </button>
                    </div>
                    : (previewImageUrl && !duplicate) ?
                      <div>
                        <div className='text-center preview-image new'><img alt={previewImageUrl} src={he.decode(previewImageUrl)} /></div>
                        <button aria-label='Remove Image' className='btn preview-image' onClick={removePreviewImage}>
                          <Icon icon='close' />
                        </button>
                      </div>
                      :
                      <FileUploadFormField
                        styleName='file-5'
                        accept='image/png,image/jpeg'
                        multiple={false}
                        onFileDrop={onPreviewImageDrop}
                        file={previewImageFile}
                        maxSize={config.maxImageFileSizeBytes}
                        dropLabel='Upload cover image (JPG, PNG)' />
                }
              </fieldset>
              <fieldset>
                <ControlGroup
                  id='event-status'
                  control='radio'
                  type='styled'
                  label={<h2>Status</h2>}
                  validation={validation.status ? null : 'Status is required.'}
                  onChange={(e) => onEventStatusChange(e)}
                  colProps={{ xs: 12, sm: 4 }}>
                  {
                    fp.map(status =>
                      <ControlOption {...eventStatusProps(status)} />
                    )(contentStatus)
                  }
                </ControlGroup>
              </fieldset>
              <fieldset>
                {
                  duplicate ? null :
                    <Button onClick={(e) => savePublishedEvent(e, false)} className='large full'>
                      {
                        isUpdatingPublishedEvent ?
                          <Spinner name='circle' className='spinner' fadeIn='none' /> :
                          `${publishedEventId ? 'Update' : 'Create'} ${eventType}`
                      }
                    </Button>
                }
                {
                  publishedEventId && isSystemAdmin && duplicate ?
                    <div className='top-gap'>
                      <Button disabled={duplicateDisabled} onClick={(e) => savePublishedEvent(e, true)} className='large full'>
                        {
                          isUpdatingPublishedEvent ?
                            <Spinner name='circle' className='spinner' fadeIn='none' /> :
                            `Duplicate ${eventType}`
                        }
                      </Button>
                    </div> : null
                }
                {
                  publishedEventId && isSystemAdmin && !duplicate ?
                    <div className='delete-content'>
                      <ConfirmationModal
                        show={showDeleteModel}
                        actions={[{
                          onConfirmAction: () => deleteEvent(publishedEventId, { eventType }, eventType === PublishedEventTypes.Event ? routes.publisherPortal.publishedEvents : routes.publisherPortal.courses),
                          actionLabel: 'Delete'
                        }]}
                        cancel={closeDeleteModel}
                        message={
                          <p>
                            You are about to delete <b>{title}</b>.
                            &nbsp;
                            Any CPD earned by users for this {fp.toLower(eventType)} will also be deleted.
                          </p>
                        }
                        headingText={<span>Delete {eventType}</span>}
                      />
                      <Button bsStyle='plain' className='warning full large' onClick={deletePublishedEvent}>
                        <Icon icon='delete-medium' /> Delete this {fp.toLower(eventType)}
                      </Button>
                    </div> : null
                }
              </fieldset>
            </form>
          </Col>
        </Row>
      </Grid>
    </section>
  )

const mapStateToProps = (state) => ({
  userCpdCategory: state.user.cpdCategoryProgress,
  cpdCategorys: state.cpdCategorys.cpdCategorys,
  industriesWithCpdCategorys: state.industry.industriesWithCpdCategorys,
  config: contentConfigSelector(state),
  isUpdatingPublishedEvent: state.publisherPortal.publishedEvent.isFetching,
  publishedEventToUpdate: state.publisherPortal.publishedEvent.eventToUpdate,
  geonames: state.geonames,
  publishers: activePublishersSelector(state),
  isSystemAdmin: fp.overSome([isSystemAdmin])(currentUserSelector(state))
})

const mapDispatchToProps = (dispatch) => ({
  getCpdCategorys: bindActionCreators(cpdCategorysActions.cpdCategorys.get, dispatch),
  searchSuburbs: bindActionCreators(geonamesActions.geonames.suburbs.get, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({
    match: {
      params: {
        publishedEventId
      }
    }
  }) => ({
    publishedEventId: publishedEventId,
  })),
  lifecycle({
    componentDidMount() {
      const { getCpdCategorys, getPublishedEventToUpdate, publishedEventId } = this.props
      getCpdCategorys()
      if (publishedEventId) {
        getPublishedEventToUpdate(publishedEventId)
      }
    }
  }),
  branch(
    ({
      publishedEventId,
      publishedEventToUpdate,
      cpdCategorys
    }) => (publishedEventId && !publishedEventToUpdate) || cpdCategorys.length === 0,
    renderComponent(Loading)
  ),
  withProps(({ publishedEventToUpdate }) => ({
    timezoneOffsets: timezones.map((tz) => ({
      ...tz,
      offset: -1 * (moment.tz.zone(tz.name).utcOffset((publishedEventToUpdate && publishedEventToUpdate.dateTimeOfEvent) ? new Date(publishedEventToUpdate.dateTimeOfEvent).getTime() : new Date().getTime()) / 60)
    }))
  })),
  withProps(({
    publishedEventToUpdate,
    timezoneOffsets
  }) => ({
    savedTimezone: publishedEventToUpdate ? fp.find(({ name }) => name === publishedEventToUpdate.timezoneName)(timezoneOffsets) : null,
    currentTimezone: fp.find(({ name }) => name === Intl.DateTimeFormat().resolvedOptions().timeZone)(timezoneOffsets)
  })),
  withProps(() => ({
    timezoneTransform: (eventStartTime, sourceTimezone, targetTimezone) => dateFnsCompat.addHours(eventStartTime, (targetTimezone.offset - sourceTimezone.offset)),
  })),
  withStateHandlers(
    ({ publishers, publishedEventToUpdate, currentTimezone, savedTimezone, timezoneTransform, eventType, cpdCategorys }) => ({
      publishedEvent: {
        ...(publishedEventToUpdate ? {
          id: publishedEventToUpdate.id,
          metaData: publishedEventToUpdate.metaData
        } : {}),
        link: publishedEventToUpdate ? publishedEventToUpdate.link : "",
        title: publishedEventToUpdate ? publishedEventToUpdate.title : "",
        description: publishedEventToUpdate ? publishedEventToUpdate.description : "",
        eventStartTime: (publishedEventToUpdate && publishedEventToUpdate.dateTimeOfEvent) ? timezoneTransform(publishedEventToUpdate.dateTimeOfEvent, currentTimezone, savedTimezone) : new Date(),
        ignoreStartTime: publishedEventToUpdate ? publishedEventToUpdate.ignoreStartTime : false,
        durationDay: publishedEventToUpdate ? publishedEventToUpdate.durationDay : 0,
        durationHour: publishedEventToUpdate ? Math.floor(publishedEventToUpdate.durationMinute / 60) : 0,
        durationMinute: publishedEventToUpdate ? (publishedEventToUpdate.durationMinute % 60) : 0,
        ignoreDuration: publishedEventToUpdate ? publishedEventToUpdate.ignoreDuration : false,
        price: publishedEventToUpdate ? publishedEventToUpdate.price : 0,
        location: publishedEventToUpdate && publishedEventToUpdate.location ? publishedEventToUpdate.location : "",
        suburb: publishedEventToUpdate ? publishedEventToUpdate.suburb : "",
        postcode: publishedEventToUpdate ? publishedEventToUpdate.postcode : "",
        status: publishedEventToUpdate ? publishedEventToUpdate.status : contentStatus.Draft.value,
        publisherId: publishedEventToUpdate ? publishedEventToUpdate.publisherId : null,
        previewImageFileName: publishedEventToUpdate ? publishedEventToUpdate.previewImageFileName : null,
        isTasaCpd: publishedEventToUpdate ? publishedEventToUpdate.isTasaCpd : false,
        eventType: publishedEventToUpdate ? publishedEventToUpdate.eventType : eventType,
        priceRange: publishedEventToUpdate ? publishedEventToUpdate.priceRange : '',
      },
      tags: publishedEventToUpdate ? publishedEventToUpdate.tags.map(({ text }) => text) : [],
      aoaCpdPoints: publishedEventToUpdate ? fp.map(({ cpdCategoryId, cpdPoints }) => ({ cpdCategoryId, points: cpdPoints }))(publishedEventToUpdate.cpdCategorys) : [getDefaultCpdPoint(cpdCategorys)],
      goals: publishedEventToUpdate ? publishedEventToUpdate.goals : [],
      newTag: undefined,
      previewImageFile: null,
      previewImageUrl: publishedEventToUpdate ? publishedEventToUpdate.previewImageUrl : undefined,
      formRef: null,
      locationOption: (publishedEventToUpdate && publishedEventToUpdate.suburb === LocationType.virtual) ? LocationType.virtual : LocationType.physical,
      startDateOption: (publishedEventToUpdate && !publishedEventToUpdate.dateTimeOfEvent) ? StartDateType.undefined : StartDateType.defined,
      suburbSearchText: null,
      period: dateFnsCompat.getHours(publishedEventToUpdate ? publishedEventToUpdate.dateTimeOfEvent : new Date()) < 12 ? 'AM' : 'PM',
      timezone: publishedEventToUpdate ? savedTimezone : currentTimezone,
      showDeleteModel: false,
      validation: {
        link: true,
        title: true,
        description: true,
        price: true,
        eventStartTime: true,
        aoaCpdPoints: true,
        aoaCpdPointsUnique: true,
        status: true,
        suburb: true,
        postcode: true
      }
    }),
    {
      updateFormField: ({ publishedEvent, suburbSearchText }) => ({ name, value }) => ({
        publishedEvent: {
          ...publishedEvent,
          suburb: suburbSearchText ? suburbSearchText : publishedEvent.suburb,
          [name]: value,
        }
      }),
      addCpdCategory: ({ aoaCpdPoints }, { cpdCategorys }) => () => ({
        aoaCpdPoints: aoaCpdPoints.concat([getDefaultCpdPoint(cpdCategorys)])
      }),
      toggleGoal: ({ goals }) => (goalId) => {
        const goalSelected = fp.includes(goalId)(goals)
        const goalsUpdated = goalSelected ?
          fp.filter(
            goal => goal !== goalId
          )(goals) :
          goals.concat([goalId])
        return {
          goals: goalsUpdated
        }
      },
      onEventStartTimeChange: ({ publishedEvent }) => (dateFunc, value) => ({
        publishedEvent: {
          ...publishedEvent,
          eventStartTime: dateFunc(publishedEvent.eventStartTime, value)
        }
      }),
      onEventStatusChange: ({ publishedEvent }) => (event) => ({
        publishedEvent: {
          ...publishedEvent,
          status: event.target.value
        }
      }),
      onIsTasaCpdChange: ({ publishedEvent }) => (event) => ({
        publishedEvent: {
          ...publishedEvent,
          isTasaCpd: event.target.checked
        }
      }),
      onIgnoreStartTimeChange: ({ publishedEvent }) => (event) => ({
        publishedEvent: {
          ...publishedEvent,
          ignoreStartTime: event.target.checked
        }
      }),
      onIgnoreDurationChange: ({ publishedEvent }) => (event) => ({
        publishedEvent: {
          ...publishedEvent,
          ignoreDuration: event.target.checked
        }
      }),
      onCpdCategoryChange: ({ aoaCpdPoints }) => (indexToChange, selectedId) => ({
        aoaCpdPoints: noCapMap(({ cpdCategoryId, points }, index) => index === indexToChange ? {
          cpdCategoryId: parseInt(selectedId, 10),
          points
        } : {
            cpdCategoryId,
            points,
          })(aoaCpdPoints),
      }),
      setCpdPoints: ({ aoaCpdPoints }) => (indexToChange, newPoints) => ({
        aoaCpdPoints: noCapMap(({ cpdCategoryId, points }, index) => index === indexToChange ? {
          cpdCategoryId,
          points: newPoints
        } : {
            cpdCategoryId,
            points,
          })(aoaCpdPoints),
      }),
      removeAoaCpdPoints: ({ aoaCpdPoints }) => (objToRemove) => ({
        aoaCpdPoints: fp.filter((aoaCpdPoint) => aoaCpdPoint !== objToRemove)(aoaCpdPoints)
      }),
      updateNewTag: ({ newTag }) => (event) => {
        event.preventDefault()
        event.stopPropagation()
        return ({
          newTag: event.target.value
        })
      },
      onAddTagKeyPress: ({ tags }) => (event) => {
        if ((event.key && event.key === 'Enter') || event.keyCode === 13) {
          event.preventDefault()
          event.stopPropagation()

          const newTag = event.target.value.trim();

          if (newTag !== '' && !fp.includes(newTag, tags)) {
            return ({
              tags: tags.concat([newTag]),
              newTag: ""
            })
          }
        }
      },
      removeTag: ({ tags }) => (tagToRemove) => ({
        tags: fp.filter((tag) => tag !== tagToRemove)(tags)
      }),
      onPreviewImageDrop: () => (acceptedFiles) => ({
        previewImageFile: fp.first(acceptedFiles)
      }),
      removePreviewImage: () => () => ({
        previewImageFile: null,
        previewImageUrl: null
      }),
      updateValidation: () => (newValidation) => ({
        validation: newValidation
      }),
      setFormRef: () => (newFormRef) => ({
        formRef: newFormRef
      }),
      onSuburbInputChange: ({ publishedEvent }) => (value) => ({
        suburbSearchText: value,
        publishedEvent: {
          ...publishedEvent,
          suburb: fp.isEmpty(value) ? '' : publishedEvent.suburb
        }
      }),
      onSuburbSelected: ({ publishedEvent, suburbSearchText }) => (suburbs) => ({
        suburbSearchText: fp.first(suburbs) ? null : suburbSearchText,
        publishedEvent: {
          ...publishedEvent,
          suburb: fp.first(suburbs) ? fp.first(suburbs).placeName : publishedEvent.suburb,
          postcode: fp.first(suburbs) ? fp.first(suburbs).postalCode : publishedEvent.postcode
        }
      }),
      onLocationOptionChange: ({ publishedEvent, locationOption }) => (value) => ({
        locationOption: value,
        publishedEvent: {
          ...publishedEvent,
          location: '',
          suburb: locationOption === LocationType.physical ? LocationType.virtual : '',
          postcode: locationOption === LocationType.physical ? '0' : ''
        }
      }),
      onStartDateOptionChange: ({ publishedEvent, startDateOption }) => (value) => ({
        startDateOption: value,
        publishedEvent: {
          ...publishedEvent
        }
      }),
      setPeriod: ({ period, publishedEvent }) => (value) => ({
        period: value,
        publishedEvent: {
          ...publishedEvent,
          eventStartTime: period === 'AM' && value === 'PM' ?
            dateFnsCompat.addHours(publishedEvent.eventStartTime, 12) :
            period === 'PM' && value === 'AM' ? dateFnsCompat.subHours(publishedEvent.eventStartTime, 12) : publishedEvent.eventStartTime
        }
      }),
      setTimezone: () => (timezone) => ({
        timezone: {
          name: timezone.name,
          offset: timezone.offset
        }
      }),
      deletePublishedEvent: () => () => ({
        showDeleteModel: true
      }),
      closeDeleteModel: () => () => ({
        showDeleteModel: false
      })
    }
  ),
  withProps(
    ({ publishedEvent, publishedEventToUpdate, currentTimezone, savedTimezone, timezoneTransform }) => {
      const linkUpdated = publishedEventToUpdate && (publishedEventToUpdate.link !== publishedEvent.link)
      const titleUpdated = publishedEventToUpdate && (publishedEventToUpdate.title !== publishedEvent.title)
      const descriptionUpdated = publishedEventToUpdate && (publishedEventToUpdate.description !== publishedEvent.description)
      const eventStartTimeUpdated = publishedEventToUpdate && (timezoneTransform(publishedEventToUpdate.dateTimeOfEvent || new Date(), currentTimezone, savedTimezone).getTime() !== publishedEvent.eventStartTime.getTime())
      const durationDayUpdated = publishedEventToUpdate && (publishedEventToUpdate.durationDay !== publishedEvent.durationDay)
      const durationHourUpdated = publishedEventToUpdate && (Math.floor(publishedEventToUpdate.durationMinute / 60) !== publishedEvent.durationHour)
      const durationMinuteUpdated = publishedEventToUpdate && ((publishedEventToUpdate.durationMinute % 60) !== publishedEvent.durationMinute)
      const durationUpdated = publishedEventToUpdate && (durationDayUpdated || durationHourUpdated || durationMinuteUpdated)
      const priceUpdated = publishedEventToUpdate && (publishedEventToUpdate.price !== publishedEvent.price)
      const locationUpdated = publishedEventToUpdate && ((publishedEventToUpdate.location || '') !== publishedEvent.location)
      const suburbUpdated = publishedEventToUpdate && (publishedEventToUpdate.suburb !== publishedEvent.suburb)
      const postcodeUpdated = publishedEventToUpdate && (publishedEventToUpdate.postcode !== publishedEvent.postcode)
      const statusUpdated = publishedEventToUpdate && (publishedEventToUpdate.status !== publishedEvent.status)
      const duplicateDisabled = !(
        linkUpdated ||
        titleUpdated ||
        descriptionUpdated ||
        eventStartTimeUpdated ||
        durationUpdated ||
        priceUpdated ||
        locationUpdated ||
        suburbUpdated ||
        postcodeUpdated ||
        statusUpdated
      )
      return {
        duplicateDisabled
      }
    }
  ),
  withProps(({ publishedEvent: { eventStartTime } }) => ({
    timezoneOffsets: timezones.map((tz) => ({
      ...tz,
      offset: -1 * (moment.tz.zone(tz.name).utcOffset(eventStartTime.getTime()) / 60)
    }))
  })),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const { publishers, publishedEvent: { publisherId }, userCpdCategory, aoaCpdPoints, onCpdCategoryChange } = nextProps;
      const { updateFormField } = this.props;
      if (!publisherId && publishers.length > 0) {
        updateFormField({ name: 'publisherId', value: fp.first(publishers).id });
      }

      if (userCpdCategory && userCpdCategory.cpdCategorys.length === 1) {
        const {
          cpdCategoryDetail: {
            cpdCategoryId
          }
        } = fp.first(userCpdCategory.cpdCategorys)
        if (fp.first(aoaCpdPoints).cpdCategoryId !== cpdCategoryId) {
          onCpdCategoryChange(0, cpdCategoryId)
        }
      }
    }
  }),
  withHandlers({
    eventStatusProps: ({ publishedEvent, validation }) => (status) => {
      return {
        key: status.value,
        value: status.value,
        label: <span>{status.label}</span>,
        checked: publishedEvent.status === status.value,
        validation: validation.status ? null : true
      };
    },
    validateForm: ({ updateValidation, publishedEvent, aoaCpdPoints, startDateOption, eventType }) => () => {
      const validation = {
        link: publishedEvent.link.trim() !== '',
        title: publishedEvent.title.trim() !== '',
        description: publishedEvent.description.trim() !== '',
        price: typeof publishedEvent.price === 'number' && publishedEvent.price >= 0,
        eventStartTime: (startDateOption === StartDateType.undefined) ? true : dateFnsCompat.isFuture(publishedEvent.eventStartTime),
        aoaCpdPoints: fp.size(aoaCpdPoints) > 0 && fp.every(aoaCpdPoint => aoaCpdPoint.cpdCategoryId && (eventType === PublishedEventTypes.Course ? true : aoaCpdPoint.points !== 0))(aoaCpdPoints),
        aoaCpdPointsUnique: (fp.size(fp.uniqBy('cpdCategoryId')(aoaCpdPoints)) === fp.size(aoaCpdPoints) && fp.size(aoaCpdPoints) > 0),
        status: publishedEvent.status,
        suburb: publishedEvent.suburb.trim() !== '',
        postcode: publishedEvent.postcode.trim() !== ''
      }
      updateValidation(validation)
      return fp.all(fp.identity)(validation)
    },
    onSuburbTextChange: ({ searchSuburbs }) => (value) => {
      if (value.length >= 3) {
        searchSuburbs({ placename: value });
      }
    },
    suburbItem: () => (option) => {
      return option.placeName;
    },
    renderSuburbResult: () => (option, props, index) => (
      he.decode(`${option.placeName}${option.postalCode !== '0' ? ` - ${option.postalCode}` : ''}`)
    )
  }),
  withHandlers({
    getHours: () => (time) => (
      dateFnsCompat.getHours(time) > 12 ? dateFnsCompat.getHours(time) - 12 : dateFnsCompat.getHours(time) === 0 ? 12 : dateFnsCompat.getHours(time)
    ),
    setHours: ({ period }) => (time, value) => (
      (period === 'AM' && value !== '12') || (period === 'PM' && value === '12') ?
        dateFnsCompat.setHours(time, value) : period === 'AM' && value === 12 ? dateFnsCompat.subHours(dateFnsCompat.setHours(time, value), 12) : dateFnsCompat.addHours(dateFnsCompat.setHours(time, value), 12)
    )
  }),
  withHandlers({
    savePublishedEvent: ({
      formRef,
      addPublishedEvent,
      updatePublishedEvent,
      publishedEvent,
      previewImageFile,
      tags,
      aoaCpdPoints,
      goals,
      validateForm,
      publishedEventId,
      suburbSearchText,
      timezone,
      savedTimezone,
      currentTimezone,
      timezoneTransform,
      eventType,
      startDateOption
    }) => (event, duplicate) => {
      event.preventDefault();
      event.stopPropagation();
      const nextRoute = {
        pathname: eventType === PublishedEventTypes.Event ? routes.publisherPortal.publishedEventDashboard : routes.publisherPortal.courseDashboard
      }
      publishedEvent = {
        ...publishedEvent,
        location: publishedEvent.location === '' ? undefined : publishedEvent.location,
        suburb: (suburbSearchText && publishedEvent.suburb !== LocationType.virtual) ? suburbSearchText : publishedEvent.suburb
      }
      if (validateForm()) {
        publishedEvent = {
          ...publishedEvent,
          eventStartTime: (startDateOption === StartDateType.defined) ? timezoneTransform(publishedEvent.eventStartTime, timezone, currentTimezone) : null,
          timezoneName: timezone.name
        }
        if (publishedEventId && !duplicate) {
          updatePublishedEvent({ publishedEvent, previewImageFile, tags, aoaCpdPoints, goals }, nextRoute, publishedEventId)
        } else {
          addPublishedEvent({ publishedEvent, previewImageFile, tags, aoaCpdPoints, goals }, nextRoute)
        }
      } else if (formRef) {
        handleInvalidForm(formRef);
      }
    },
  }),
  branch(
    ({ publishers }) => publishers.length === 0,
    renderComponent(Loading)
  )
)(EventDetails)


// WEBPACK FOOTER //
// ./src/containers/pages/shared/publish-event/event-details.js